import { createFileRoute } from '@tanstack/react-router';
import { HrLeavePage } from '@/features/leave/hr-leave-page';
import { guardRoute } from '@/lib/route-guards';

/** `/hr/leave` (FR-LEAVE-8): the leave register, balances and calendar. */
export const Route = createFileRoute('/_app/hr/leave')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/leave');
  },
  component: HrLeavePage,
});
